// extracted by mini-css-extract-plugin
export var checked = "checkbox-module--checked--TBOib";
export var checkedCenter = "checkbox-module--checkedCenter--ajtT-";
export var dontShow = "checkbox-module--dontShow--vWBjD";
export var generalCheckboxStyles = "checkbox-module--generalCheckboxStyles--MT6a0";